(function () {
  var DEBUG = /[?&]bundle_debug=1\b/.test(location.search);
  function log(msg, data) {
    if (DEBUG) console.log('[bundle-bridge] ' + msg, data == null ? '' : data);
  }

  function realRadios() {
    var nodes = document.querySelectorAll('.bundle-vp-hidden variant-picker input.js-option');
    if (nodes.length) return nodes;
    return document.querySelectorAll('variant-picker input.js-option');
  }

  function optionNameOf(radio) {
    var sel = radio.closest('.option-selector');
    return sel ? sel.dataset.option : null;
  }

  function onClick(e) {
    var btn = e.target.closest('.bundle-opt-btn');
    if (!btn) return;
    e.preventDefault();
    var name = btn.dataset.optionName;
    var value = btn.dataset.value;
    log('click ' + name + '=' + value);
    var radios = realRadios();
    for (var i = 0; i < radios.length; i++) {
      if (optionNameOf(radios[i]) === name && radios[i].value === value) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          log('triggered radio id=' + radios[i].id);
        }
        return;
      }
    }
    log('NO MATCH for ' + name + '=' + value);
  }

  function syncVisualState() {
    var radios = realRadios();
    var byName = {};
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) byName[optionNameOf(radios[i])] = radios[i].value;
    }
    var btns = document.querySelectorAll('.bundle-opt-btn');
    for (var j = 0; j < btns.length; j++) {
      var match = byName[btns[j].dataset.optionName] === btns[j].dataset.value;
      btns[j].classList.toggle('is-selected', match);
    }
    var labels = document.querySelectorAll('.bundle-opt-selected[data-option-index]');
    for (var k = 0; k < labels.length; k++) {
      var idx = labels[k].dataset.optionIndex;
      var hit = document.querySelector('.bundle-opt-btn.is-selected[data-option-index="' + idx + '"]');
      if (hit) labels[k].textContent = hit.dataset.value;
    }
  }

  function init() {
    var btnCount = document.querySelectorAll('.bundle-opt-btn').length;
    var radioCount = realRadios().length;

    // Fallback: bundle_items metafield set but no custom buttons rendered
    // (e.g. product not on the bundle-v2 template). Unhide the native picker.
    if (btnCount === 0 && radioCount > 0) {
      var hidden = document.querySelectorAll('.bundle-vp-hidden');
      for (var i = 0; i < hidden.length; i++) hidden[i].classList.remove('bundle-vp-hidden');
      log('no bundle-opt-btn found, native picker restored');
      return;
    }

    log('init buttons=' + btnCount + ' radios=' + radioCount);
    syncVisualState();
  }

  document.addEventListener('click', onClick);
  document.addEventListener('on:variant:change', syncVisualState);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
